// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2c5Hx","col":"styles_col__1ow1c"};